import * as React from "react";
import slotLogo from "src/assets/logo/slot.svg";
import betLogo from "src/assets/logo/bet.svg";
import sportLogo from "src/assets/logo/sport.svg";

export type GameChannel = "SLOT" | "BET" | "SPORT";

const channelLogo: Record<GameChannel, string> = {
  SLOT: slotLogo,
  BET: betLogo,
  SPORT: sportLogo,
};

const ChannelLogo: React.FunctionComponent<{ channel?: GameChannel }> = ({ channel }) => {
  if (!channel) return null;
  return <img src={channelLogo[channel]} alt={channel} style={{ height: 14, display: "block" }} />;
};

export default ChannelLogo;
